import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[app-insights-library__item-selector__item-preview]',
  standalone: false
})
export class InsightsLibraryItemSelectorItemPreviewDirective {
  constructor(public readonly templateRef: TemplateRef<unknown>) {
  }
}
